import React from 'react';
import { Table, Heading } from '@zillow/constellation';
import { ICheckDisbursementResponse } from '../../../../../types/order/escrow/response/ICheckDisbursementResponse';
import { CheckDisbursementRow } from './CheckDisbursementRow';

interface ICheckDisbursementsTableProps {
  checkDisbursements: ICheckDisbursementResponse[];
}

const tableHeaders = [
  'Check #',
  'Name',
  'Additional Name',
  'Address',
  'Amount',
  'Memo',
  'Category',
  'Account',
  'Account #',
  'WF Trans #',
  'Delivery Code',
  'Sent',
  'Completed',
  'Enqueued',
];

export const CheckDisbursementsTable: React.FC<ICheckDisbursementsTableProps> = ({ checkDisbursements }) => {
  return (
    <>
      <Heading level={1}>Check Disbursements</Heading>
      <Table aria-label="Check Disbursements" size={'sm'} appearance={'zebra'}>
        <Table.Header appearance={'dark'}>
          <Table.Row>
            {tableHeaders.map((header) => (
              <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {checkDisbursements.map((item) => (
            <CheckDisbursementRow key={item.id} item={item} />
          ))}
        </Table.Body>
      </Table>
    </>
  );
};
